// extracted by mini-css-extract-plugin
export default {"rounded-top-column":"DifferentiatedChart_rounded-top-column__F-qD7"};